import { gql } from "@apollo/client";

import { remoteAssetFragment } from "../fragments/remoteAssetFragment";

export const getRemoteAsset = gql`
    query getRemoteAsset($id: ID!, $lensUsageCursor: String, $lensUsageLimit: Int = 10) {
        remoteAsset(input: { id: $id }) {
            ...RemoteAssetFields
            usedByLensesConnection(cursor: $lensUsageCursor, limit: $lensUsageLimit) {
                nodes {
                    lensId
                    lensName
                }
                cursor
            }
        }
    }
    ${remoteAssetFragment}
`;
